export default "__VITE_ASSET__40664579__"